import { GridRenderEditCellParams } from '@mui/x-data-grid';

import { TargetAttributeDto, TargetAttributeDtoType } from '@/generated/model';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { Checkbox, Typography } from '@mui/material';
import { fulldate } from '@/utilities/dateUtils';

export default function TypeBasedDisplay({ params }: { params: GridRenderEditCellParams }) {
  // params.value is the valueGetter transformed value. The original value accessible from row variable
  const { isEditable, row } = params;
  const { t } = useTranslation();

  if (!isEditable) {
    // These are the value columns next to tag counters
    return;
  }
  const isVarious = row.various;
  return (
    <span className={`target-attribute-value ${isVarious ? 'target-attribute-value--various' : ''}`}>
      {getContent(row, t)}
    </span>
  );
}

function getContent(targetAttribute: TargetAttributeDto, t: TFunction<'translation', undefined>) {
  if (!targetAttribute.value && targetAttribute.various) {
    return <Typography variant="stateText">{t('targetAttributes.variousValues')}</Typography>;
  }

  // 0 is valid value
  const attributeValue = targetAttribute.value;
  if (attributeValue == undefined || attributeValue == null || String(attributeValue) == '') {
    return <div className="empty-target-attribute"></div>;
  }

  switch (targetAttribute.type) {
    case TargetAttributeDtoType['@class']:
      return (
        <>
          {attributeValue.brand} {attributeValue.type}
        </>
      );
    case TargetAttributeDtoType['@list']:
      return <>{attributeValue.translation}</>;
    case TargetAttributeDtoType['@boolean']:
      return <Checkbox className="disabled" checked={Boolean(attributeValue)} />;
    case TargetAttributeDtoType['@date']: {
      if (Number(attributeValue) === 0) {
        return <div className="empty-target-attribute"></div>;
      }
      const value = attributeValue ? fulldate(Number(attributeValue) * 1000, t) : null;
      return <>{value}</>;
    }
    default:
      return <>{attributeValue}</>;
  }
}
